import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
const Transition = ({ children, fadeInStyle, fadeOutStyle, show, }) => {
    const [shouldRender, setShouldRender] = useState(show);
    useEffect(() => {
        if (show) {
            setShouldRender(true);
        }
    }, [show]);
    const onAnimationEnd = () => {
        if (!show) {
            setShouldRender(false);
        }
    };
    return shouldRender ? (_jsx("div", { className: `${show ? fadeInStyle : fadeOutStyle}`, onAnimationEnd: onAnimationEnd, children: children })) : null;
};
export { Transition };
